import React, { lazy, Suspense } from 'react';
import {
    Switch,
    Route,
} from "react-router-dom";
import Loader from './../components/loader/Loader';
import ErrorBoundary from './ErrorBoundary';
import { color } from './../utilities/constants';
import NotFound from './../pages/notfound/NotFound';

const publicRoutes = [
    {
        path: '/',
        exact: true,
        component: lazy(() => import('./../pages/home/Home')),
    },
    {
        path: '/huong-nghien-cuu',
        exact: true,
        component: lazy(() => import('./../pages/objective/Objective')),
    },
    {
        path: '/de-tai',
        exact: true,
        component: lazy(() => import('./../pages/topic/Topic')),
    },
    {
        path: '/thuc-tap',
        exact: true,
        component: lazy(() => import('./../pages/intership/Intership')),
    },
    {
        path: '/san-pham',
        exact: true,
        component: lazy(() => import('./../pages/project/Project')),
    },
    {
        path: '/lich-su',
        exact: true,
        component: lazy(() => import('./../pages/history/History')),
    },
    {
        path: '/nhom-nghien-cuu',
        exact: true,
        component: lazy(() => import('./../pages/team/Team')),
    },
    {
        path: '/doi-tac',
        exact: true,
        component: lazy(() => import('./../pages/partner/Partner')),
    },
]

const RouterConfig = (props) => {
    return (
        <ErrorBoundary>
            <Suspense fallback={<Loader color={color.primary} size={10} />}>
                <Switch>
                    {publicRoutes.map((route, index) => {
                        return (
                            <Route key={index} path={route.path} exact={route.exact}>
                                <route.component theme={props.theme} data={props.data}/>
                            </Route>
                        )
                    })}
                    <Route path={'*'}>
                        <NotFound />
                    </Route>
                </Switch>
            </Suspense>
        </ErrorBoundary>
    )
}

export default RouterConfig;